import { Bell } from "lucide-react";

type NotificationDotProps = {
  hasNotification?: boolean;
};

export function NotificationDot({ hasNotification = true }: NotificationDotProps) {
  return (
    <button
      type="button"
      aria-label={hasNotification ? "Notifications (new)" : "Notifications"}
      className="relative flex h-9 w-9 items-center justify-center rounded-md text-ink-3 transition hover:bg-paper-2 hover:text-ink"
    >
      <Bell size={18} />
      {hasNotification && (
        <span className="absolute right-1.5 top-1.5 dot bg-tide" />
      )}
    </button>
  );
}
